/**
 * @author: subhasish.ghosh@zoom.us
 */

export const SET_AUTHENTICATION = "SET_AUTHENTICATION";

export const setAuthentication = (isAuthenticated) => ({
  type: SET_AUTHENTICATION,
  payload: isAuthenticated,
});
